import React, { useState } from 'react'
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from 'react-router-dom'

import {
    Purchase,
    PurchaseLot,
    ContractPosition,
    ContractSupplier,
} from '../../../types'

import FooterRightToolbarButtons from './Buttons/FooterRightToolbarButtons'

type NavState = {
    from?: 'purchase' | 'purchase_lot' | 'registry'
    purchaseRegNumber?: string
    fromStage?: string | null
    fromYear?: string | number | null
}

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseLotGuid: string | undefined
    purchaseLot: PurchaseLot
    purchase: Purchase

    user_guid: string | null
    purchase_user_guid: string
    purchase_supervisor_user_guid: string
    role: string

    stage: string
    status: string
}

const Footer: React.FC<Props> = (props) => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()

    const navState = (location.state ?? {}) as NavState

    const [isSaving, setSaving] = useState<boolean>(false)

    const handleClose = () => {
        // если пришли из реестра — вернемся туда же и на ту же стадию
        if (navState.from === 'registry') {
            navigate(
                `/hub/purchases?year=${navState.fromYear}&stage=${navState.fromStage ?? props.stage}`,
                {
                    replace: true,
                }
            ) // <-- подставь свой реальный роут реестра
            return
        }

        // иначе (пришли из закупки / нет state) — возвращаемся в закупку
        const purchaseRegNumber =
            navState.purchaseRegNumber ?? params.purchaseRegNumber
        if (purchaseRegNumber && navState.from === 'purchase') {
            navigate(
                `/hub/purchase/${purchaseRegNumber}?tab=${encodeURIComponent('Документация')}`,
                { replace: true }
            )
            return
        }

        if (purchaseRegNumber && navState.from === 'purchase_lot') {
            const perf_action = props.purchaseAction ? 'edit' : 'draft'
            navigate(
                `/hub/purchase/${purchaseRegNumber}/purchases/${perf_action}/${props.purchase.guid}/?tab=${encodeURIComponent('Лоты')}`,
                {
                    state: {
                        from: 'purchase',
                        purchaseRegNumber: props.purchase.registration_number,
                    },
                }
            )
            return
        }

        // совсем fallback
        navigate('/hub/purchases/', { replace: true })
    }

    return (
        <footer className="flex flex-row w-full min-h-10 items-center justify-end ">
            <div className="flex flex-row gap-2 p-2 px-[22px] w-full h-full bg-[#d2d5d8] dark:bg-[#262427] items-center justify-start">
                <div className="flex flex-1"></div>
                <FooterRightToolbarButtons
                    theme={props.theme}
                    purchaseAction={
                        !!(
                            props.purchaseAction ||
                            props.purchase.purchase_stage === 'Отправка в ЕИС'
                        )
                    }
                    actions={{
                        close: handleClose,
                    }}
                    isLoading={isSaving}
                />
            </div>
        </footer>
    )
}

export default Footer
